import PaddingMarginGrid from './PaddingMarginGrid';
import { PaddingMarginGridProps, PaddingMarginGridValueProps } from './types';

export type { PaddingMarginGridProps, PaddingMarginGridValueProps };
export default PaddingMarginGrid;
